import React, { useEffect, useState, useCallback, useMemo } from 'react'
import produce from 'immer'

import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { withRouter,useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import qs from 'qs'

import components3 from 'components3'

import DotLoader from '../Loaders/DotLoader'

import {
  loadView3,
  loadForm3,
  runEffect3,
  dispatchEvent3,
  subscribe3,
  requestForm3Section,
  login3,
  collect3,
  changeStatus3,
  requestChangeStatus3,
  setUserPersistentProfile,
  confirmPubSub3,
  confirmValidationMessage,
  setFormStop3,
  download3,
  addNote3,
  saveView3,
  cancelLogin,


} from "../../actions";

import { push, replace, goBack } from "connected-react-router";


import {
  getView3Nodes,
  getView3Id,
  getView3TemplateId,
  getView3Loading,
  getEffects,
  getPubSub3,
  getEffectsLoading,
  getIsInputDisabled,
  getErrors,
  getWarnings,
  getForm3Nodes,
  getForm3Id,
  getForm3Loading,
  getForm3ActiveSection,
  getForm3State,
  getForm3Connections,
  getIsAuthenticated,
  getUser,
  getUserPersistentProfile,
  getForm3ValidationMessage,
  getForm3ValidationErrors,
  getForm3Stop,
  getForm3Data,
  getConfiguration3,
  getHTMLTemplates3,
  getView3Data,
  getAuthStatus,
  getForm3Process,
  getLoginSession
} from "../../reducers";

import StandardComponent from './StandardComponent'

const LoginOverlay = styled.div`
  position:fixed;
  top: 10px;
  left: 10px;
  background-color: rgba(0,0,0,0.5); 
  color: pink;
  
`

const CenterWrapper = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  height:100vh;
`

const ViewRoot = withTheme((props) => {

  const {
    loadView,
    viewLoading,
    viewNodes,
    viewId,
    match,
    runEffect,
    currentState,
    templateId,
    dispatchEvent,
    subscribe,
    isInputDisabled,
    setActiveFormSection,
    activeFormSection,
    isAuthenticated,
    user = {},
    userPersistentProfile,
    setUserPersistentProfile,
    validationMessage,
    validationErrors,
    confirmValidationMessage,
    location = {},
    stop,
    formData = {},
    setStop,
    download,
    configuration,
    htmlTemplates,
    addNote,
    viewData,
    formProcess,
    authStatus,
    collect,
    loginSession
  } = props;

  const url = match.params.url;
  const id = match.params.id;

  const { search } = location

  const queryParams = useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search])

  // const [viewData, setViewData] = useState({});

  useEffect(() => {

    const options = { ...queryParams }

    if( id ) {
      options.formId = id
    }

    loadView(url, options)

    // Adding dependencies?? Check the loadView only runs ONCE when, esp for services!
  }, [url])

  const formDataId = formData._id

  // not sure what this did/does.
  // it DID however screw up the history and push value two times the the histry, causing back to go bonkers
  // useEffect( () => {
  //   if( formDataId ) {
  //     // const params = new URLSearchParams()
  //     queryParams.formDataId = formDataId

  //    //props.history.push({search: qs.stringify(queryParams)})

  //     localStorage.setItem('activeFormDataId',formDataId)
  //   }
  // }, [formDataId])

  const _runEffect = useCallback(props => {
    runEffect(props)
  }, [runEffect])

  // we callbakced this 2020-09, could leed to problems..
  // const saveSingle = useCallback(({ key, value }) => {
  //   if (!key) {
  //     return
  //   }
  //   setViewData(produce(draft => {
  //     draft[key] = value
  //   }))
  // }, [setViewData])

  const save = useCallback( ({ key, value, context }) => {
    props.save({ key, value, id: formDataId });
  }, [])

  if (!viewNodes) {
    return <CenterWrapper><DotLoader/></CenterWrapper>
  }

  const rootNode = viewNodes[templateId ? templateId : viewId]

  if (!rootNode) {
    return <div>NO ROOT NODE</div>
  }



  const baseStyle = produce(props.theme.standardComponent, d => {

    const directions = ['Top', 'Bottom', 'Right', 'Left']

    directions.forEach(direction => {
      if (d[`margin${direction}`]) {
        d[`margin${direction}`] = `${d[`margin${direction}`]}${d.marginUnit}`
      }
    })

    if (d.paddingTop) {
      d.paddingTop = `${d.paddingTop}${d.paddingUnit}`
    }

  })

  return (
    <React.Fragment>
      {
        rootNode.structure.map(nodeId => {
          

          return <StandardComponent
            nodeId={nodeId}
            key={nodeId}
            nodes={viewNodes}
            components={components3.components}
            rootId={viewId}
            templateId={templateId}
            save={save}
            viewData={viewData}
            data={viewData}
            formData={formData}
            formProcess={formProcess}
            match={match}
            subscribe={subscribe}
            dispatchEvent={dispatchEvent}
            runEffect={_runEffect}
            loadForm={props.loadForm}
            effects={props.effects}
            effectsLoading={props.effectsLoading}
            pubSub={props.pubSub}
            confirmPubSub={props.confirmPubSub3}
            isInputDisabled={isInputDisabled}
            errors={props.errors}
            warnings={props.warnings}
            formNodes={props.formNodes}
            formId={props.formId}
            setActiveFormSection={setActiveFormSection}
            activeFormSection={activeFormSection}
            push={props.push}
            replace={props.replace}
            goBack={props.goBack}
            login={props.login}
            connections={props.connections}
            changeStatus={props.changeStatus}
            theme={props.theme}
            baseStyle={baseStyle}
            queryParams={queryParams}
            user={user}
            userPersistentProfile={userPersistentProfile}
            setUserPersistentProfile={setUserPersistentProfile}
            currentState={currentState}
            validationMessage={validationMessage}
            validationErrors={validationErrors}
            confirmValidationMessage={confirmValidationMessage}
            stop={stop}
            setStop={setStop}
            download={download}
            configuration={configuration}
            htmlTemplates={htmlTemplates}
            addNote={addNote}
            authStatus={authStatus}
            cancelLogin={props.cancelLogin}
            collect={collect}
            loginSession={loginSession}
          />
        })
      }
    </React.Fragment>
  )
})

const mapStateToProps = (state, ownProps) => ({
  viewLoading: getView3Loading(state),
  viewNodes: getView3Nodes(state),
  viewId: getView3Id(state),
  currentState: getForm3State(state),
  pubSub: getPubSub3(state),
  templateId: getView3TemplateId(state),
  effects: getEffects(state),
  effectsLoading: getEffectsLoading(state),
  isInputDisabled: getIsInputDisabled(state),
  errors: getErrors(state),
  warnings: getWarnings(state),
  formLoading: getForm3Loading(state),
  formData: getForm3Data(state),
  formNodes: getForm3Nodes(state),
  formId: getForm3Id(state),
  activeFormSection: getForm3ActiveSection(state),
  connections: getForm3Connections(state),
  isAuthenticated: getIsAuthenticated(state),
  userPersistentProfile: getUserPersistentProfile(state),
  validationMessage: getForm3ValidationMessage(state),
  validationErrors: getForm3ValidationErrors(state),
  user: getUser(state),
  stop: getForm3Stop(state),
  configuration: getConfiguration3(state),
  htmlTemplates: getHTMLTemplates3(state),
  viewData: getView3Data(state),
  authStatus: getAuthStatus(state),
  formProcess: getForm3Process(state),
  loginSession: getLoginSession(state)

});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    runEffect: ({ source, effectId, componentId, pageId, pageType, context }) => {
      const queryParams = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true })
      dispatch(runEffect3({ source, context: { ...context, queryParams }, componentId, pageId, pageType, effectId }));
    },
    save: ({ key, value, data, id }) => {
      dispatch(saveView3({ key, value, data, id }));
    },
    loadView: (url, queryParams) => {
      dispatch(loadView3({ url: url ? url : ownProps.match.params.url, queryParams }));
    },
    loadForm: ({ formId, formDataId }) => {
      dispatch(loadForm3({ formId, formDataId }));
    },
    dispatchEvent: ({ pageType, pageId, nodeId, event, context }) => {
      const queryParams = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true })
      dispatch(dispatchEvent3({ pageType, pageId, nodeId, event, context: { ...context, queryParams } }));
    },
    subscribe: ({ channel }) => {
      dispatch(subscribe3({ channel }));
    },
    setActiveFormSection: ({ index, direction, ignoreValidationErrors = false, force = false, effects }) => {
      dispatch(requestForm3Section({ index, direction, ignoreValidationErrors, force,effects }));
    },
    push: (url) => {
      dispatch(push(url));
    },
    replace: (url) => {
      dispatch(replace(url));
    },
    goBack: () => {
      dispatch(goBack());
    },
    login: ({ strategy = 'local', props }) => {
      dispatch(login3({ strategy, props }));
    },
    collect: ({ strategy = 'local', props, session, source }) => {
      dispatch(collect3({ strategy, props,session, source }));
    },
    cancelLogin: ({ strategy, session }) => {
      dispatch(cancelLogin({ strategy, session }))
    },
    changeStatus: ({ formId, formDataId, currentStateId, connectionId, to, force }) => {
      // dispatch(changeStatus3({formId, formDataId,currentStateId,connectionId,to}));
      dispatch(requestChangeStatus3({ formId, formDataId, currentStateId, connectionId, to, force }));
    },

    setUserPersistentProfile: (payload) => {
      dispatch(setUserPersistentProfile(payload));
    },

    confirmPubSub3: ({ id, channel }) => {
      dispatch(confirmPubSub3({ id, channel }));
    },

    confirmValidationMessage: () => {
      dispatch(confirmValidationMessage({}));
    },
    setStop:  (stop) => {
      dispatch(setFormStop3({stop}));
    },
   
    download:  ({id,page}) => {
      dispatch(download3({id,page}));
    },
    addNote: ({ noteType = "external", note, formDataId }) => {
      const noteId = uuidv4();
      dispatch(addNote3({ noteType, note, formDataId, noteId }));
    },
   


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter((ViewRoot))
);
